import type { ChangeEvent } from 'react';
import { useMemo, useState } from 'react';
import { Avatar, Button, Spinner, TextArea } from '@radix-ui/themes';
import currentProfile from 'helpers/currentProfile';
import { sendMessage } from 'store/newMessage/newMessageSlice';
import { useAppDispatch, useAppSelector } from 'store/store';
import type { MessageAuthorType } from 'types/user';

export const MessageBox: React.FC<{
  thumbnail: string;
  name: string;
  recipient: MessageAuthorType;
  isBlocked?: boolean;
}> = ({ thumbnail, name, recipient, isBlocked = false }) => {
  const { loading } = useAppSelector((state) => state.newMessage);

  const currProfile = useAppSelector((state) => state.profileSelector.currentProfile);
  const profile = useMemo(
    () =>
      currentProfile({
        index: currProfile,
      }),
    [currProfile],
  );
  const dispatch = useAppDispatch();
  const [content, setContent] = useState('');
  const onChange = (event: ChangeEvent<{ value: string }>) => {
    setContent(event.target.value);
  };
  const avatarImage =
    recipient.type === 'fit_player_profile'
      ? 'player-avatar'
      : recipient.type === 'club_manager_profile'
        ? 'tennisclub-avatar'
        : 'user-avatar';
  return (
    <div
      id='container'
      className='border-neutral-neutral-3 bg-neutral-neutral-1 flex w-full flex-col items-center gap-4 self-stretch rounded-2xl border border-solid p-3'
    >
      <div id='player' className='flex items-center gap-2 self-stretch p-2'>
        <div id='avatar' className='flex h-8 w-8 items-center gap-2 self-stretch fill-transparent'>
          <Avatar
            alt='Avatar Utente'
            className='flex h-8 w-8 rounded-md'
            src={thumbnail}
            fallback={<img src={`/images/${avatarImage}.jpg`} />}
          />
        </div>
        <div id='nome'>
          <div className='truncate, text-neutral-neutral-12 text-base font-bold'>{name}</div>
        </div>
      </div>
      <div id='textarea' className='w-full'>
        <TextArea size='3' variant='classic' placeholder='Scrivi un messaggio' value={content} onChange={onChange} />
      </div>

      <div id='buttons' className='flex w-full items-center justify-end gap-2'>
        <div id='invia'>
          {loading ? (
            <Spinner />
          ) : (
            <Button
              size='2'
              disabled={!content.trim() || !recipient || isBlocked}
              onClick={() => {
                dispatch(sendMessage({ message: content, sender: profile!, recipient: recipient! })).then(() =>
                  setContent(''),
                );
              }}
            >
              Invia
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageBox;
